import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CLINIC } from "@/lib/clinicInfo";
import { SERVICES } from "@/data/services";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-border bg-secondary/50 mt-24" data-testid="footer">
      <div className="container-wide py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img
              src={CLINIC.logo}
              alt="Nehchal Eye Centre"
              className="h-12 w-auto object-contain"
              loading="lazy"
            />
            <div className="leading-tight border-l border-border pl-3">
              <div className="font-serif text-base text-primary">Nehchal Eye Centre</div>
              <div className="text-[10px] tracking-[0.2em] uppercase text-foreground/60">Sector 32 · Noida</div>
            </div>
          </div>
          <p className="text-sm text-muted-foreground leading-6">
            Fellowship-trained eye care by Dr. Gurkiran Kaur in Sector 32, Wave City Centre, Noida. Advanced cataract, oculoplasty, glaucoma and pediatric eye care.
          </p>
        </div>

        <div>
          <div className="text-sm font-semibold text-foreground mb-4 tracking-wide uppercase">Services</div>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="text-foreground/70 hover:text-primary"
                  data-testid={`footer-service-${s.slug}`}
                >
                  {s.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/services" className="text-primary hover:opacity-80">
                View all services →
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-foreground mb-4 tracking-wide uppercase">Quick Links</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="text-foreground/70 hover:text-primary">About Dr. Kaur</Link></li>
            <li><Link to="/blog" className="text-foreground/70 hover:text-primary">Eye Health Blog</Link></li>
            <li><Link to="/contact" className="text-foreground/70 hover:text-primary">Book Appointment</Link></li>
            <li><a href={CLINIC.mapUrl} target="_blank" rel="noopener noreferrer" className="text-foreground/70 hover:text-primary">Directions</a></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-foreground mb-4 tracking-wide uppercase">Contact</div>
          <ul className="space-y-3 text-sm text-foreground/80">
            <li className="flex gap-2">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
              <span>{CLINIC.address.line1}, {CLINIC.address.line2}</span>
            </li>
            <li className="flex gap-2">
              <Phone className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
              <a href={`tel:${CLINIC.phoneRaw}`} className="hover:text-primary">{CLINIC.phone}</a>
            </li>
            <li className="flex gap-2">
              <Mail className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
              <a href={`mailto:${CLINIC.email}`} className="hover:text-primary">{CLINIC.email}</a>
            </li>
            <li className="flex gap-2">
              <Clock className="h-4 w-4 mt-0.5 shrink-0 text-primary" />
              <span>Mon–Sat 9AM–7PM · Sun 10AM–1PM</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="container-wide py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {year} Nehchal Eye Centre. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/admin" className="hover:text-foreground" data-testid="footer-admin-link">Admin</Link>
            <span>Made in Noida, India</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
